import React, { useEffect, useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import axios from "axios";
import { useHistory } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';

if (!localStorage.getItem('locale')) {
    localStorage.setItem('locale', 'en');
}

const useStyles = makeStyles((theme) => ({
    root: {
        opacity: '88%',
        borderRadius: '5px'
    },
    companyLogo: {
        height: 80,
        margin: theme.spacing(3),
    },
    mainGrid: {
        paddingTop: '15vh',
        height: '30vh',
    },
    image: {
        backgroundImage: 'url(images/login.png)',
        backgroundRepeat: 'no-repeat',
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    paper: {
        backgroundColor: '#FFF',
        padding: theme.spacing(4, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
        textAlign: 'center'
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    video: {
        width: '100%',
        height: '100%',
        position: 'fixed',
        zIndex: '-10',
        backgroundColor: '#000',
        filter: 'blur(5px)',
        WebkitFilter: 'blur(5px)'
    },
    errorMsg: {
        marginBottom: '10px'
    }
}));

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            SUNeVision
            {' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export default function SignInSide(props) {
    const classes = useStyles();
    const history = useHistory();
    const { instance, inProgress, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const videoSource = "videos/Office Background Video HD.mp4";
    const [loginLoading, setLoginLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        localStorage.removeItem('employee_name');
        localStorage.removeItem('token');
        localStorage.removeItem('staff_duty');
        localStorage.removeItem('selectedIndex');
        localStorage.removeItem('isApplicationOpen');
        localStorage.removeItem('isMyRequestOpen');
        localStorage.removeItem('isLeaveApprovalOpen');
        localStorage.removeItem('isHRAdminOpen');
        localStorage.removeItem('isHrAdminRole');
        localStorage.removeItem('department_id');
    }, []);
    
    useEffect(() => {
        const accessTokenRequest = {
            scopes: ["user.read"],
            account: accounts[0]
        };

        const handleLogin = async () => {
            try {
                setLoginLoading(true);

                const accessTokenResponse = await instance.acquireTokenSilent(accessTokenRequest);
                const accessToken = accessTokenResponse.accessToken;

                await axios.get(`${process.env.REACT_APP_API_URL}/sanctum/csrf-cookie`);
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/loginAD`, { token: accessToken });

                setLoginLoading(false);
                localStorage.setItem('token', response.data.token);
                const destination = localStorage.getItem('destination');
                if (!destination) {
                    history.push("/home");
                } else {
                    localStorage.removeItem('destination');
                    history.push(destination);
                }
            } catch (error) {
                console.error(error);
                setLoginLoading(false);
                if (error.response) {
                    setErrorMsg(error.response.data.msg);
                } else if (error.errorCode === "interaction_required" || error.errorCode === "login_required" || error.errorCode === "consent_required") {
                    instance.loginRedirect(accessTokenRequest).catch(console.error);
                } else {
                    setErrorMsg('User not found.');
                }
            }
        };

        if (inProgress === InteractionStatus.None && isAuthenticated) {
            handleLogin();
        } else if (inProgress === InteractionStatus.None && !isAuthenticated) {
            instance.loginRedirect(accessTokenRequest).catch(console.error);
        }
    }, [inProgress, isAuthenticated, accounts, instance, history]);

    return (
        <div>
            <video autoPlay loop muted playsInline className={classes.video}>
                <source src={videoSource} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            <Container component="main" maxWidth="xs">
                <div className={classes.root}>
                    <Grid container className={classes.mainGrid}>
                        <CssBaseline />
                        <Grid item xs={12} component={Paper} elevation={6} square>
                            <div className={classes.paper}>
                                <img src="images/Logo_of_SUNeVision.png" className={classes.companyLogo} alt="SUNeVision Logo" />
                                <Typography component="h1" variant="h5">
                                    {process.env.REACT_APP_TITLE}
                                </Typography>
                                <form className={classes.form} noValidate>
                                    <div className={classes.wrapper}>
                                        {isAuthenticated && loginLoading &&
                                            <Alert severity="info">
                                                Authorizing, please wait...
                                                <CircularProgress style={{ width: '12px', height: '12px' }} />
                                            </Alert>
                                        }
                                        {errorMsg &&
                                            <Alert severity="error" className={classes.errorMsg}>
                                                {errorMsg} <br />
                                                If the issue is still encountered, please raise JIRA Ticket (
                                                <a href="https://sunevision.atlassian.net/servicedesk/customer/portal/6">JIRA Ticket</a>).
                                            </Alert>
                                        }
                                    </div>
                                    <Box mt={5}>
                                        <Copyright />
                                    </Box>
                                </form>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Container>
        </div>
    );
}